import React from 'react'
import './Card.css'
import { Link, useNavigate } from 'react-router-dom'
import { DeleteSingleBlog } from '../../actions/BlogAction'
import { useDispatch } from 'react-redux'

function Card({val}) {

    const dispatch = useDispatch()
    const navigate = useNavigate()
  
    const handleDelete = async () => {
      const userConfirmed = window.confirm('Are you sure you want to delete?');
      if (userConfirmed) {
        try {
          await dispatch(DeleteSingleBlog(val._id));
          navigate('/allblogs');
          window.location.reload();
        } catch (error) {
          console.error('Error deleting blog:', error);
        }
      } else {
      }
    };
  
    return (
        <div className='card'>
            <div className='card_div'>
                <div className='img_div'>
                    <img src={val.imageurl} alt='' />
                </div>
                <div className='card_text_div'>
                    <div className='card_heading'>{`${(val.mainheading).substring(0, 30)}...`}</div>
                    <div className='card_para'>{`${(val.maincontent).substring(0, 75)}...`}
                    </div>
                </div>
                <div className='card_button_div'>
                    <Link to={`/editblog/${val._id}`} className='Link_button'>Edit</Link>
                    <button type="button" onClick={handleDelete} className='Link_button'>Delete</button>
                </div>
            </div>
        </div>
    )
}

export default Card
